// extracted by mini-css-extract-plugin
export default {"sobre_main":"sobre_sobre_main__ixaDM"};